import { useApi, createApiHook } from "../utils/apiUtils";

const useAssignappUpdateStatus = () => {
  const { apiPatch } = useApi();
  const useApiState = createApiHook(null);
  const { data, error, loading, startLoading, setResponse } = useApiState();

  const updateAssignappStatus = async ({ assignapp_id, status }) => {
    startLoading();
    const response = await apiPatch(`/assignapps/${assignapp_id}/update_status`, "Error al actualizar el estado", { status });
    setResponse(response);
  };

  return { updateAssignappStatus, data, loading, error };
};

export default useAssignappUpdateStatus;
